module.exports = __webpack_public_path__ + "img/vision_02_2x.1ea7b1c2.jpg";